module.exports = __webpack_public_path__ + "static/img/pinJie2.4189789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pinJie2.png
// module id = EtHw
// module chunks = 2